interface IGeneratedPresignedUrlRes {
  data: {
    originalFilename: string;
    filename: string;
    presignedUrl: string;
  }[];
}

export const generatePresignedUrl = async ({
  siteId,
  campaignId,
  filenames,
}: {
  siteId: string;
  campaignId: string;
  filenames: string[];
}): Promise<IGeneratedPresignedUrlRes> => {
  try {
    if (!filenames || filenames.length === 0) {
      // eslint-disable-next-line no-console
      console.warn("filename is empty");
      return { data: [] };
    }

    if (!siteId || !campaignId) {
      return { data: [] };
    }

    const res = await fetch(PUBLIC_API_URL + "/presigned-url/generate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        siteId,
        campaignId,
        filename: filenames.map((filename) => filename),
      }),
    });

    if (!res.ok) {
      throw new Error("Failed to generate presigned URL");
    }

    return await res.json();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return { data: [] };
  }
};

export const uploadFileByPresignedUrl = async ({
  presignedUrl,
  file,
}: {
  presignedUrl: string;
  file: File;
}): Promise<{ status: "success" | "fail"; message?: string }> => {
  try {
    if (!presignedUrl || !file) {
      throw new Error("Invalid argument");
    }

    const res = await fetch(presignedUrl, {
      method: "PUT",
      body: file,
    });

    if (!res.ok) {
      throw new Error("Failed to upload file");
    }

    return {
      status: "success",
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return {
      status: "fail",
      message: (e as Error).message,
    };
  }
};

export const uploadedFilePath = ({
  siteId,
  campaignId,
  filename,
}: {
  siteId: string;
  campaignId: string;
  filename: string;
}) => {
  return `${S3_UPLOAD_PREFIX}/form/files/${siteId}/${campaignId}/${filename}`;
};
